import { defineModule } from '../../utils/helpers';

const onFormComplete = (
  event: Record<string, any>,
  form: HTMLFormElement,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  response: { errors: string[]; content: string; pass: boolean },
) => {
  const formIdElement = form.querySelector<HTMLInputElement>(
    'input[name="form_id"]',
  );
  if (!formIdElement) return;

  const formId = formIdElement.value;
  const formMessageWrapperElement = document.getElementById(
    `frm_form_${formId}_container`,
  );
  if (!formMessageWrapperElement) return;

  const modalElement = formMessageWrapperElement.closest('.modal');
  if (modalElement) {
    modalElement.classList.add('modal--form-completed');
  }
};

export default defineModule(
  () => {
    jQuery(document).on('frmFormComplete', onFormComplete);
  },
  () => {
    jQuery(document).off('frmFormComplete', onFormComplete);
  },
);
